import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthServiceService } from 'src/app/shared/services/auth-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { AlertService } from 'ngx-alerts';
import * as jwt_decode from 'jwt-decode';
import { CustomValidator } from 'src/app/validators/custom-validator';
import { OthersService } from 'src/app/shared/services/other-services/others.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

@Component({
  selector: 'app-loan-amortize-type',
  templateUrl: './loan-amortize-type.component.html',
  styleUrls: ['./loan-amortize-type.component.scss'],
})
export class LoanAmortizeTypeComponent implements OnInit {
  modalRef: BsModalRef;
  userForm: FormGroup;
  loading: boolean = false
  User = this.authService.loggedInUserInfo();
  checkedClient: {
    customerId?: number
    fktheStationLocationIdCustomer?: number
  };
  types = [
    { name: 'FLAT RATE', code: 1 },
    { name: 'REDUCING BALANCE WITH REDUCING INSTALMENT', code: 2 },
    { name: 'REDUCING BALANCE WITH CONSTANT INSTALMENT', code: 3 },
  ];
  customers: Array<any>;
  statement: Array<any>;
  selectionKind: number;
  selectionData: Array<any>;
  modalTitle: string;

  constructor(
    private authService: AuthServiceService,
    private others: OthersService,
    private alertService: AlertService,
    private modalService: BsModalService
  ) { }

  ngOnInit(): void {
    this.userForm = this.createFormGroup();
    this.others.getMicroCustomersByTown(this.User.userLocationId).subscribe(
      res => {
        this.loading = false
        if (res.length > 0) {
          this.customers = [];
          this.customers = res;

        } else {
          this.alertService.danger({
            html: '<b>There are no Micro loan customers registered</b>'
          });
        }
      },
      err => {
        this.loading = false;
        this.alertService.danger({
          html: '<b>' + err + '</b>'
        });
      }
    );
  }

  createFormGroup(): any {
    return new FormGroup({
      type: new FormControl(
        '',
        Validators.compose([Validators.required])
      ),

    });
  }
  revert(): any {
    this.userForm = this.createFormGroup();
    this.checkedClient = null
  }
  get fval(): any {
    return this.userForm.controls;
  }

  // modal method
  public openModal(template: TemplateRef<any>): any {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'modal-lg modal-dialog-centered' })
    );
  }

  getResult(res: any): void {
    this.checkedClient = res;
    this.modalRef.hide();
  }
  getClose(res: any): void {
    this.modalRef.hide();
  }

  getStatement(template: TemplateRef<string>): void {
    this.others.microCustomerStatement(this.checkedClient.customerId).subscribe(
      res => {
        this.statement = res;
        if (this.statement.length === 0) {
          this.alertService.success({
            html: '<b>Customer has no previous transactions</b>'
          });
        } else this.openModal(template);
      },
      err => {
        this.alertService.danger({
          html: `<b> ${err}</b>`
        });
      }
    );
  }

  selectFromData(template: TemplateRef<any>, kind: number): void {
    if (kind === 100) {
      this.openModal(template);
      this.selectionKind = kind;
      this.selectionData = this.customers;
      this.modalTitle = "Select a Client";
    }
  }

  setAmortizationType(): any {
    if (this.userForm.valid) {
      this.loading = true
      const data = {
        customerId: this.checkedClient.customerId,
        productCode: 400,
        userId: this.User.userId,
        theLoanAmortizationType: Number(this.fval.type.value),
        theStationLocationId: this.checkedClient.fktheStationLocationIdCustomer,
        comment: 'Please set the amortization type of this customer to' + this.types.filter(
          t => t.code == this.fval.type.value)[0].name
      };

      this.others
        .putSetIndividualLoanAmortizationType(data)
        .subscribe(
          (res) => {
            this.loading = false
            this.alertService.success({
              html:
                '<b> The amortization type was initiated successfully</b>',
            });
            this.revert();
          },
          (err) => {
            this.loading = false
            this.alertService.danger({
              html: '<b>' + err + '</b>',
            });
          }
        );
    }

  }
}
